import { COLORS, newLayout } from '../theme';

export default {
  styleOverrides: {
    tooltip: {
      maxWidth: 256,
      padding: `${newLayout.spacing.s3} ${newLayout.spacing.s4}`,
      fontSize: newLayout.fontSize.body2,
      fontWeight: 400,
      lineHeight: newLayout.lineHeight.body2,
      background: COLORS.black90,
      borderRadius: newLayout.borderRadius.secondary,
    },
    arrow: {
      color: COLORS.black90,
      fontSize: 12,
    },
  },
};
